class WebSocketService {
    constructor() {
      this.socket = null;
      this.eventHandlers = {};
    }
  
    connect(userID) {
      const WS_ENDPOINT = `wss://igocqr11r9.execute-api.us-east-1.amazonaws.com/dev?userID=${userID}`;
      this.socket = new WebSocket(WS_ENDPOINT);
  
      this.socket.onopen = () => {
        // console.log("WebSocket connected");
        // this.sendMessage({ action: "connect", userID });
      };
  
      this.socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        // console.log("Message received:", message);
  
        if (this.eventHandlers[message.event]) {
          this.eventHandlers[message.event](message);
        }
      };
  
      this.socket.onclose = () => {
        // console.log("WebSocket disconnected");
      };
  
      this.socket.onerror = (error) => {
        // console.error("WebSocket error:", error);
      };
    }
  
    sendMessage(data) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify(data));
      }
    }
  
    on(event, handler) {
      this.eventHandlers[event] = handler;
    }
  
    disconnect(userID) {
      this.sendMessage({ action: "disconnect", userID });
      this.socket.close();
    }
  }
  
  export const webSocketService = new WebSocketService();
  